import React, { useRef, useEffect, useState } from 'react';
import './index.less';

const PageTop = props => {
    const { anchor, current, onChange, BubbleMachine } = props;
    const graphVW = anchor.isMobile ? 1.52 : 1.2635;

    const drawItems = (titles) => {
        let result = [];
        const currentStyle = {
            color: '#0296ff',
            fontSize: "22px",
            transformOrigin: 'bottom',
            borderBottom: "4px solid #0296ff"
        }
        titles.forEach((title, index) => {
            result.push((
                <div className="title_item_box" key={index}>
                    <div className="title_item"
                        style={index == titles.length - 1 - current ? currentStyle : undefined}
                        onClick={() => onChange && onChange(titles.length - 1 - index)}>{title}</div>
                </div>
            ));
        })
        return result;
    }

    return (
        <div className="pagetop">
            <div style={{
                position: 'absolute',
                width: `${anchor.totalWidth * 1.2}px`,
                height: "100vh",
                left: `${-anchor.totalWidth * 0.1}px`,
                top: '0px',
            }}>
                <img src='/assets/top_bg.jpg' style={{ width: "100%", height: "100vh" }} />
            </div>
            <div className="title_bar">
                <img
                    src='/assets/top1.png'
                    className="top1"
                    style={{ width: `${anchor.scale * 382}px`, minWidth: 150 }} />
                <img
                    src='/assets/top2.png'
                    className="top2"
                    style={{ width: `${anchor.scale * 212}px`, minWidth: 80 }} />
                <img
                    src='/assets/top3.png'
                    className="top3"
                    style={{ width: `${anchor.scale * 68}px`, minWidth: 30 }} />
                <img
                    src='/assets/top4.png'
                    className="top4"
                    style={{ width: `${anchor.scale * 192}px`, minWidth: 60 }} />
                <img
                    src='/assets/top5.png'
                    className="top5"
                    style={
                        anchor.isMobile ? {
                            width: `${anchor.scale * 396}px`,
                            right: "-10%",
                            top: "-70%",
                            minWidth: "120px"
                        } : {
                                right: "-4%",
                                top: "-170%",
                            }
                    } />
                {
                    // !anchor.isMobile && drawItems(["联系我们", "高度关注专家学者", "小脉星探", "评项目", "评论文", "评人才", "引人才", "找专家",'人才画像库', "首页"])
                    !anchor.isMobile && drawItems(["联系我们", "合作伙伴", "应用案例", "AI筛选", "学者画像", "首页"])
                }
            </div>
            <div className='contents'>
                <div className="pagetop_con">
                    <div className="pagetop_left" >
                        <div className="pagetop_left_img">
                            <div>
                                <img src='/assets/top_text_1.png' style={{ width: `${anchor.scale * 402}px`, minWidth: 192 }} />
                                {
                                    !anchor.isMobile
                                    && 
                                    <img
                                        src='/assets/top_text_6.png'
                                        className='top_text_6'
                                        style={{ width: `${anchor.scale * 26}px`, minWidth: 16 }}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="pagetop_right" >
                        <div className="pagetop_right_img">
                            <img src='/assets/top_graph.png' style={{ width: `${anchor.scale * 784}px`, minWidth: 300 }} />
                        </div>
                        {
                            !!anchor.isMobile
                            &&
                            <img
                                src='/assets/top_text_6.png'
                                className='top_text_6'
                                style={{ width: `${anchor.scale * 26}px`, minWidth: 16 }}
                            />
                        }
                    </div>

                </div>


            </div>

            <div style={{ position: "relative", width: "100vh", height: "100vh" }}>
                <img
                    src='/assets/top6.png'
                    className="top6"
                    style={
                        anchor.isMobile ? {

                            width: "240px",
                            left: "0px",
                            bottom: "-10%",
                        } : {
                                left: "-10%",
                                bottom: "-10%",
                            }
                    } />
            </div>
            <div className='bubble'>
                {
                    current == 0 && <BubbleMachine anchor={anchor} vw={graphVW} bgColor='#cae6fe' />
                }
            </div>
        </div>
    )
}

export default PageTop;